import { Typography } from "@mui/material"
//MESSAGE THAT ARE GENERAL ACROSS THE SYSTEM, NOT SPECIFIC TO A CHILD/PERSON/SESSION
export type SystemModalType = "LOADING" | "NO_SUBSCRIPTIONS_LEFT" | "SUBSCRIPTION_RENEWED" | "DUPLICATE_FIELD" | "REMOVE_ASSIGNMENT" | "SAVED_CHANGES" | "SAVED_ASSIGNMENTS" | "REACTIVATE" | "NO_DATA_TO_VIEW" | "NOT_ENOUGH_REFERENCES" | "EDIT_IN_PROGRESS" | "DISPOSITION_DETAILS" | "GENERAL_ERROR" | "UNKNOWN" | null;
export const SystemModalMessage = {
    "LOADING": (
        <Typography>One moment please</Typography>
    ),
    "SUBSCRIPTION_RENEWED": (
        <Typography>Subscription Renewed</Typography>
    ),
    "NO_SUBSCRIPTIONS_LEFT": (
        <Typography>There are no more subscriptions this company can add</Typography>
    ),
    'DUPLICATE_FIELD': (
        <Typography>
            Custom field at this location with same type and name exists already.
        </Typography>
    ),
    'NO_DATA_TO_VIEW': (
        <Typography>
            No data for this answer
        </Typography>
    ),
    'REMOVE_ASSIGNMENT': (
        <Typography>
            This will remove this User’s access (it will NOT expire the User’s record). Do you wish to proceed?
        </Typography>
    ),
    'SAVED_CHANGES': (
        <Typography>
            Successfully saved!
        </Typography>
    ),
    'SAVED_ASSIGNMENTS': (
        <Typography>
            Successfully saved!
        </Typography>
    ),
    'REACTIVATE': (
        <Typography>
            Please contact your futuresTHRIVE representative for assistance reactivating a User. Support@FuturesThrive.com
        </Typography>
    ),

    'NOT_ENOUGH_REFERENCES': (
        <Typography>
            This User cannot be removed (de-linked) because at least 1 Admin must be associated with a child record. Another Admin User must be linked before this User can be removed.
        </Typography>
    ),
    "EDIT_IN_PROGRESS": (
        <div>
            <Typography>One minute, we are making the update</Typography>
        </div>
    ),
    "DISPOSITION_DETAILS": (
        <div>
            <Typography>Each child has been categorized based on what they reported in their most recent results.</Typography>
        </div>
    ),
    'GENERAL_ERROR': (
        <div>
            <Typography sx={theme => ({ color: theme.palette.error.main, fontWeight: 'bold' })}>
                Error!
            </Typography>
            <Typography sx={{ padding: "8px 0px" }}>
                Something has gone wrong. The incident has been logged and sent to support. Please try again in a few.
            </Typography>
        </div>
    ),
    'UNKNOWN': (
        <Typography>
            Message type not recognized
        </Typography>
    ),
}
